export default function Footer() {
  return (
    <footer className="flex-1 py-4 text-center text-xs text-gray-200 bg-gradient-to-r from-blue-600 via-blue-700 to-blue-900 flex items-center justify-center">
      © {new Date().getFullYear()} AWC Consultoria Sistemas Ltda. Todos os direitos reservados.
    </footer>
  );
}